import { MapService } from './map.service';
import { NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchService } from '../search.service';
import { StateService } from '../state/state.service';
import { MapboxService } from './mapbox/mapbox.service';
import { AuthService } from '../../auth/auth.service';
import { FlagService } from '../flag/flag.service';
import { T2, T8, T13, T14 } from './layer/layer-definitions';
import { EncryptedDataService } from '~app/auth/encrypted-data.service';
import { TranslateService } from '@ngx-translate/core';

const layerDefinitions = {
  2: T2,
  8: T8,
  13: T13,
  14: T14
};

export function mapServiceFactory() {
  return (
    http: HttpClient,
    ngZone: NgZone,
    searchService: SearchService,
    stateService: StateService,
    flagService: FlagService,
    authService: AuthService,
    encryptedData: EncryptedDataService,
    translateService: TranslateService): MapService => {

    const mapService: MapService = new MapboxService(stateService, http, searchService, flagService, ngZone, encryptedData, authService, translateService);

    return mapService;
  };
}

export const mapServiceProvider = {
  provide: MapService,
  useFactory: mapServiceFactory(),
  deps: [
    HttpClient,
    NgZone,
    SearchService,
    StateService,
    FlagService,
    AuthService,
    EncryptedDataService,
    TranslateService
  ]
};
